import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { ImagesModule } from 'angular-shared-features/feature/custom-image/module/image-module';
import { PresentationalComponentsModule } from '../components/components.module';
import { SharedComponentsModule } from 'angular-shared-features/feature/shared-component/module/shared-component.module';
import { SharedDirectivesModule } from 'angular-shared-features/feature/shared-directives/module/shared.directives.module';
import { SharedPipesModule } from 'angular-shared-features/feature/shared-pipe/module/shared.pipes.module';
import { VgCoreModule } from "videogular2/core";
import { VgControlsModule } from "videogular2/controls";
import { VgOverlayPlayModule } from "videogular2/overlay-play";
import { VgBufferingModule } from "videogular2/buffering";
import { VgStreamingModule } from "videogular2/streaming";
import { SwiperModule } from 'angular-shared-features/feature/swiper/module/swiper.module';
import { ClipboardModule } from 'ngx-clipboard';
import { PlaceContainer } from './place-container/place-container.component';
import { PageContainer } from './page-container/page-container.component';
import { ListContainer } from './list-container/list-container.component';
import { EventContainer } from './event-container/event-container.component';
import { GridContainer } from './grid-container/grid-container.component';
import { ProfileContainer } from './profile-container/profile-container.component';
import { VideoContainer } from './video-container/video-container.component';
import { EmbedVideoContainer } from './video-container/embed/embed.video-container.component';
import { DocumentContainer } from './document-container/document-container.component';
import { SeriesContainer} from './series-container/series-container.component';
import { SeasonContainer} from './season-container/season-container.component';
import { PlaylistContainer } from './playlist-container/playlist-container.component';
import { SearchContainer } from './search-container/search-container.component';
import { FormContainer } from './form-container/form-container.component';
import { TagsContainer} from './tags-container/tags-container.component';
import { NotFoundContainer } from './notfound-container/notfound-container.component';
import { UserInfoContainer } from './user.info-container/user.info-container.component';
import { MatDatepickerModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule( {
    imports: [
        CommonModule,
        BrowserModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgStreamingModule,
        PresentationalComponentsModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedDirectivesModule,
        ImagesModule,
        RouterModule,
        SwiperModule,
        ClipboardModule,
        MatDatepickerModule, 
        MatMomentDateModule
    ],
    declarations: [
        PlaceContainer,
        PageContainer,
        EventContainer,
        GridContainer,
        ProfileContainer,
        ListContainer,
        DocumentContainer,
        VideoContainer,
        EmbedVideoContainer,
        SeriesContainer,
        SeasonContainer,
        PlaylistContainer,
        SearchContainer,
        FormContainer,
        NotFoundContainer,
        TagsContainer,
        UserInfoContainer
],
    exports: [
        PlaceContainer,
        PageContainer,
        EventContainer,
        GridContainer,
        ProfileContainer,
        ListContainer,
        DocumentContainer,
        VideoContainer,
        EmbedVideoContainer,
        SeriesContainer,
        SeasonContainer,
        PlaylistContainer,
        SearchContainer,
        FormContainer,
        NotFoundContainer,
        TagsContainer,
        UserInfoContainer
    ],
    entryComponents: [
        PlaceContainer,
        PageContainer,
        EventContainer,
        GridContainer,
        ProfileContainer,
        ListContainer,
        DocumentContainer,
        VideoContainer,
        EmbedVideoContainer,
        SeriesContainer,
        SeasonContainer,
        PlaylistContainer,
        SearchContainer,
        FormContainer,
        NotFoundContainer,
        TagsContainer,
        UserInfoContainer
    ],
    providers: [
    ]
} )
export class ContainerComponentsModule {

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/containers.module.ts